// TermsOfService.js
import { Typography, Grid, Icon, Link } from '@mui/material';
import { Gavel, Public, Feedback } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    // padding: theme.spacing(4),
    padding: "1em",
    maxWidth: 1200,
    margin: '0 auto'
  },
  section: {
    // marginBottom: theme.spacing(4)
    marginBottom: "1em"
  },
  icon: {
    // marginRight: theme.spacing(2),
    marginRight: "1em",
    verticalAlign: 'middle'
  }
}));

const TermsOfService = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h3" gutterBottom>
        <Gavel className={classes.icon} />
        Afri-Rate Terms of Service
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} className={classes.section}>
          <Typography variant="h5" gutterBottom>
            <Public className={classes.icon} />
            Service Usage
          </Typography>
          <Typography>
            Afri-Rate provides real-time USDT/USDC exchange rates for African currencies. 
            Rates are estimates and should not be used for financial decisions.
          </Typography>
        </Grid>

        <Grid item xs={12} md={6} className={classes.section}>
          <Typography variant="h5" gutterBottom>
            <Icon className={classes.icon}>📊</Icon>
            Data Collection
          </Typography>
          <Typography>
            We store your country/currency preference locally via localStorage. 
            No personal data is collected without consent.
          </Typography>
        </Grid>

        <Grid item xs={12} className={classes.section}>
          <Typography variant="h5" gutterBottom>
            <Feedback className={classes.icon} />
            User Responsibilities
          </Typography>
          <Typography>
            By using Afri-Rate, you agree to:
            <ul>
              <li>Not misuse rate data</li>
              <li>Provide accurate feedback when submitted</li>
              <li>Acknowledge rate volatility</li>
            </ul>
          </Typography>
          <Link href="/feedback" color="primary">
            Submit Feedback
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

export default TermsOfService;